// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".snap{scroll-snap-type:var(--scroll-snap-direction) var(--scroll-snap-constraint)}.snap-x{--scroll-snap-direction:x}.snap-mandatory{--scroll-snap-constraint:mandatory}.snap-start{scroll-snap-align:start}.snap-center{scroll-snap-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
